// Percent widths for the table's `<colgroup>`. Each map sums to 100%.
export type CommunicationColumnKey =
    | 'reference'
    | 'practice'
    | 'title'
    | 'categories'
    | 'assignee'
    | 'entries'
    | 'lastActivity'
    | 'status'
    | 'rowMenu';

export const COMMUNICATION_COL_WIDTHS: {
    withPractice: Record<CommunicationColumnKey, string>;
    withoutPractice: Record<CommunicationColumnKey, string>;
} = {
    withPractice: {
        reference: '9%',
        practice: '12%',
        title: '22%',
        categories: '13%',
        // `assignee` hosts a live dropdown and can never be given a clipping
        // backstop, so it gets a bit more room than `entries`/`lastActivity`.
        assignee: '11%',
        entries: '10%',
        lastActivity: '10%',
        status: '10%',
        rowMenu: '3%'
    },
    withoutPractice: {
        reference: '10%',
        // Never rendered - showPractice gates the Practice column off before
        // this key is looked up - but Record<CommunicationColumnKey, string>
        // requires every key, so both maps stay exhaustive by the type system.
        practice: '12%',
        title: '27%',
        categories: '15%',
        assignee: '12%',
        entries: '11%',
        lastActivity: '11%',
        status: '11%',
        rowMenu: '3%'
    }
};

export function communicationColWidths(
    showPractice: boolean
): Record<CommunicationColumnKey, string> {
    return showPractice
        ? COMMUNICATION_COL_WIDTHS.withPractice
        : COMMUNICATION_COL_WIDTHS.withoutPractice;
}
